export default __webpack_public_path__ + "static/media/screen_facebook_5_1.750d45c4.png";